module.exports = __webpack_public_path__ + "static/media/tyre-expert.bb1f047d.svg";